// source: livongo/protobuf/grpc/external/enrollment/common/password_rule.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.CharGroup', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RuleCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.oneofGroups_);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.oneofGroups_ = [[1,2,3,4,5,6,7,8,9]];

/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RuleCase = {
  RULE_NOT_SET: 0,
  MIN_LENGTH: 1,
  MAX_LENGTH: 2,
  REQUIRED_CHAR_FROM_GROUPS: 3,
  INVALID_CHARACTERS: 4,
  FORBID_REPEATED: 5,
  FORBID_SEQUENTIAL: 6,
  FORBID_REUSED: 7,
  FORBID_DICTIONARY: 8,
  FORBID_MATCHED_HACKED: 9
};

/**
 * @return {proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RuleCase}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.getRuleCase = function() {
  return /** @type {proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RuleCase} */(jspb.Message.computeOneofCase(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.toObject = function(includeInstance, msg) {
  var f, obj = {
    minLength: (f = msg.getMinLength()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength.toObject(includeInstance, f),
    maxLength: (f = msg.getMaxLength()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength.toObject(includeInstance, f),
    requiredCharFromGroups: (f = msg.getRequiredCharFromGroups()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.toObject(includeInstance, f),
    invalidCharacters: (f = msg.getInvalidCharacters()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters.toObject(includeInstance, f),
    forbidRepeated: (f = msg.getForbidRepeated()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated.toObject(includeInstance, f),
    forbidSequential: (f = msg.getForbidSequential()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential.toObject(includeInstance, f),
    forbidReused: (f = msg.getForbidReused()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused.toObject(includeInstance, f),
    forbidDictionary: (f = msg.getForbidDictionary()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary.toObject(includeInstance, f),
    forbidMatchedHacked: (f = msg.getForbidMatchedHacked()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength.deserializeBinaryFromReader);
      msg.setMinLength(value);
      break;
    case 2:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength.deserializeBinaryFromReader);
      msg.setMaxLength(value);
      break;
    case 3:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.deserializeBinaryFromReader);
      msg.setRequiredCharFromGroups(value);
      break;
    case 4:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters.deserializeBinaryFromReader);
      msg.setInvalidCharacters(value);
      break;
    case 5:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated.deserializeBinaryFromReader);
      msg.setForbidRepeated(value);
      break;
    case 6:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential.deserializeBinaryFromReader);
      msg.setForbidSequential(value);
      break;
    case 7:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused.deserializeBinaryFromReader);
      msg.setForbidReused(value);
      break;
    case 8:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary.deserializeBinaryFromReader);
      msg.setForbidDictionary(value);
      break;
    case 9:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked.deserializeBinaryFromReader);
      msg.setForbidMatchedHacked(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMinLength();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength.serializeBinaryToWriter
    );
  }
  f = message.getMaxLength();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength.serializeBinaryToWriter
    );
  }
  f = message.getRequiredCharFromGroups();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.serializeBinaryToWriter
    );
  }
  f = message.getInvalidCharacters();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters.serializeBinaryToWriter
    );
  }
  f = message.getForbidRepeated();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated.serializeBinaryToWriter
    );
  }
  f = message.getForbidSequential();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential.serializeBinaryToWriter
    );
  }
  f = message.getForbidReused();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused.serializeBinaryToWriter
    );
  }
  f = message.getForbidDictionary();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary.serializeBinaryToWriter
    );
  }
  f = message.getForbidMatchedHacked();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength.toObject = function(includeInstance, msg) {
  var f, obj = {
    min: (f = msg.getMin()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setMin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Int32Value min = 1;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength.prototype.getMin = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 1));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength.prototype.setMin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength.prototype.clearMin = function() {
  return this.setMin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength.prototype.hasMin = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength.toObject = function(includeInstance, msg) {
  var f, obj = {
    max: (f = msg.getMax()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setMax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMax();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Int32Value max = 1;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength.prototype.getMax = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 1));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength.prototype.setMax = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength.prototype.clearMax = function() {
  return this.setMax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength.prototype.hasMax = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.toObject = function(includeInstance, msg) {
  var f, obj = {
    requiredGroupsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.CharGroup>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addRequiredGroups(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequiredGroupsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.CharGroup = {
  INVALID: 0,
  LOWER: 1,
  UPPER: 2,
  DIGIT: 3,
  SPECIAL: 4
};

/**
 * repeated CharGroup required_groups = 1;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.CharGroup>}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.prototype.getRequiredGroupsList = function() {
  return /** @type {!Array<!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.CharGroup>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.CharGroup>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.prototype.setRequiredGroupsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.CharGroup} value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.prototype.addRequiredGroups = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups.prototype.clearRequiredGroupsList = function() {
  return this.setRequiredGroupsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated.toObject = function(includeInstance, msg) {
  var f, obj = {
    maxRepetition: (f = msg.getMaxRepetition()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setMaxRepetition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMaxRepetition();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Int32Value max_repetition = 1;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated.prototype.getMaxRepetition = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 1));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated.prototype.setMaxRepetition = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated.prototype.clearMaxRepetition = function() {
  return this.setMaxRepetition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated.prototype.hasMaxRepetition = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential.toObject = function(includeInstance, msg) {
  var f, obj = {
    maxSequenceLength: (f = msg.getMaxSequenceLength()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setMaxSequenceLength(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMaxSequenceLength();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Int32Value max_sequence_length = 1;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential.prototype.getMaxSequenceLength = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 1));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential.prototype.setMaxSequenceLength = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential.prototype.clearMaxSequenceLength = function() {
  return this.setMaxSequenceLength(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential.prototype.hasMaxSequenceLength = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional MinLength min_length = 1;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.getMinLength = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength, 1));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MinLength|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.setMinLength = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.clearMinLength = function() {
  return this.setMinLength(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.hasMinLength = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional MaxLength max_length = 2;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.getMaxLength = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength, 2));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.MaxLength|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.setMaxLength = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.clearMaxLength = function() {
  return this.setMaxLength(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.hasMaxLength = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional RequiredCharFromGroups required_char_from_groups = 3;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.getRequiredCharFromGroups = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups, 3));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.RequiredCharFromGroups|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.setRequiredCharFromGroups = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.clearRequiredCharFromGroups = function() {
  return this.setRequiredCharFromGroups(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.hasRequiredCharFromGroups = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional InvalidCharacters invalid_characters = 4;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.getInvalidCharacters = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters, 4));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.InvalidCharacters|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.setInvalidCharacters = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.clearInvalidCharacters = function() {
  return this.setInvalidCharacters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.hasInvalidCharacters = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ForbidRepeated forbid_repeated = 5;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.getForbidRepeated = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated, 5));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidRepeated|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.setForbidRepeated = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.clearForbidRepeated = function() {
  return this.setForbidRepeated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.hasForbidRepeated = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional ForbidSequential forbid_sequential = 6;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.getForbidSequential = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential, 6));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidSequential|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.setForbidSequential = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.clearForbidSequential = function() {
  return this.setForbidSequential(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.hasForbidSequential = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional ForbidReused forbid_reused = 7;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.getForbidReused = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused, 7));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidReused|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.setForbidReused = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.clearForbidReused = function() {
  return this.setForbidReused(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.hasForbidReused = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional ForbidDictionary forbid_dictionary = 8;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.getForbidDictionary = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary, 8));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidDictionary|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.setForbidDictionary = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.clearForbidDictionary = function() {
  return this.setForbidDictionary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.hasForbidDictionary = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional ForbidMatchedHacked forbid_matched_hacked = 9;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.getForbidMatchedHacked = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked, 9));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.ForbidMatchedHacked|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.setForbidMatchedHacked = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.clearForbidMatchedHacked = function() {
  return this.setForbidMatchedHacked(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule.prototype.hasForbidMatchedHacked = function() {
  return jspb.Message.getField(this, 9) != null;
};


goog.object.extend(exports, proto.com.livongo.protobuf.grpc.external.enrollment.common);
